// extracted by mini-css-extract-plugin
export var wrap = "styles-module--wrap--1obVH";
export var title = "styles-module--title--144YP";
export var text = "styles-module--text--1Eqcl";
export var inner = "styles-module--inner--2GIzr";
export var button = "styles-module--button--2nkGM";
export var img = "styles-module--img--p5hdW";